export var InvoiceQueryStatus;
(function (InvoiceQueryStatus) {
    InvoiceQueryStatus["OPEN"] = "open";
    InvoiceQueryStatus["RESOLVED"] = "resolved";
})(InvoiceQueryStatus || (InvoiceQueryStatus = {}));
export var InvoiceQueryReason;
(function (InvoiceQueryReason) {
    InvoiceQueryReason["PRICING"] = "pricing";
    InvoiceQueryReason["QUANTITY"] = "quantity";
    InvoiceQueryReason["QUALITY"] = "quality";
    InvoiceQueryReason["NOT_RECEIVED"] = "not_received";
    InvoiceQueryReason["DUPLICATE"] = "duplicate";
    InvoiceQueryReason["OTHER"] = "other";
})(InvoiceQueryReason || (InvoiceQueryReason = {}));
export const InvoiceQueryReasonLabels = {
    [InvoiceQueryReason.PRICING]: `Pricing`,
    [InvoiceQueryReason.QUANTITY]: `Quantity`,
    [InvoiceQueryReason.QUALITY]: `Quality`,
    [InvoiceQueryReason.NOT_RECEIVED]: `Not received`,
    [InvoiceQueryReason.DUPLICATE]: `Duplicate`,
    [InvoiceQueryReason.OTHER]: `Other`,
};
export var InvoiceQueryResolution;
(function (InvoiceQueryResolution) {
    InvoiceQueryResolution["PAID"] = "paid";
    InvoiceQueryResolution["CREDIT_NOTE"] = "credit_note";
    InvoiceQueryResolution["VOIDED"] = "voided";
    InvoiceQueryResolution["WITHDRAWN"] = "withdrawn";
    InvoiceQueryResolution["WRITTEN_OFF"] = "written_off";
})(InvoiceQueryResolution || (InvoiceQueryResolution = {}));
export const InvoiceQueryResolutionLabels = {
    [InvoiceQueryResolution.PAID]: `Paid`,
    [InvoiceQueryResolution.CREDIT_NOTE]: `Credit note issued`,
    [InvoiceQueryResolution.VOIDED]: `Invoice voided`,
    [InvoiceQueryResolution.WITHDRAWN]: `Withdrawn`,
    [InvoiceQueryResolution.WRITTEN_OFF]: `Written off`,
};
export var InvoiceQuerySource;
(function (InvoiceQuerySource) {
    InvoiceQuerySource["USER"] = "user";
    InvoiceQuerySource["PORTAL"] = "portal";
    InvoiceQuerySource["AI_AGENT"] = "ai_agent";
    InvoiceQuerySource["ESCALATION"] = "escalation";
    /** From the follow ups suggested after a click to call */
    InvoiceQuerySource["CALL"] = "call";
})(InvoiceQuerySource || (InvoiceQuerySource = {}));
//# sourceMappingURL=invoiceQuery.js.map